import React, {useEffect, useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {DetailHeroSummaryProvider, DetailTabBar} from "../../../../components/detailLayout";
import {getAsset} from "../../../../api/asset/AssetService";
import {getCodes} from "../../../../api/code/CodeService";
import {getCustomCodeList, getCustomStringList} from "../../../../api/field/CustomCodeService";
import {getFields} from "../../../../api/field/FieldService";
import {error} from "../../../../redux/slice/apiSlice";
import {getFlatCode, isMobile} from "../../../../components/commonmethod/CommonMethod";
import {updatePageTabTitle} from "../../../../components/pageTabs/pageTabsStorage";
import AssetInfo from "./subPages/view/AssetInfo";
import {CommonHistoryList} from "../../../settings/history/subPages/CommonHistoryList";
import AssetLicense from "./AssetLicense";
import AssetContract from "./AssetContract";
import {AssetMaintenance} from "./AssetMaintenance";
import AssetMenoTab from "./AssetMenoTab";
import AssetLease from "./AssetLease";
import {AssetDepreciation} from "./AssetDepreciation";
import AssetPurchase from "./AssetPurchase";
import "../../../../components/detailLayout/detailListLayout.css";
import "./subPages/view/assetInfo.css";

function AssetView() {
    const { id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const platFrom = useSelector((state) => state.auth.platFrom);

    const [asset, setAsset] = useState();
    const [flat, setFlat] = useState();
    const [customCodes, setCustomCodes] = useState([]);
    const [customStrings, setCustomStrings] = useState([]);
    const [fields, setFields] = useState([]);
    const [tabs, setTabs] = useState();

    useEffect(() => {
        setTabs([
            { clicked: true, name: "기본정보" },
            { clicked: false, name: "구매관리" },
            { clicked: false, name: "라이선스 관리" },
            { clicked: false, name: "계약관리" },
            { clicked: false, name: "리스관리" },
            { clicked: false, name: "감가상각관리" },
            { clicked: false, name: "이력관리" },
            platFrom !== "IAM"
                ? { clicked: false, name: "유지보수업무" }
                : { clicked: false, name: "자산기록관리" },
        ]);
    }, [platFrom]);

    useEffect(() => {
        setAsset(undefined);
        getFields()
            .then((res) => {
                setFields(res.data);
                return getAsset(id).then((a) => {
                    if (a.status === 200) {
                        setAsset(a.data);
                    } else if (a.status === 201) {
                        if (a.data.errorCode === "AUTHORITY") {
                            alert(a.data.reason);
                            navigate(-1);
                        }
                    }
                });
            })
            .catch((err) => {
                dispatch(error({ code: err.response?.status || 500 }));
            });
    }, [id, location.pathname, dispatch, navigate]);

    useEffect(() => {
        getCodes().then((res) => {
            setFlat(getFlatCode(res.data.content));
        });
        getCustomCodeList().then((res) => {
            setCustomCodes(res.data);
        });
        getCustomStringList().then((res) => {
            setCustomStrings(res.data);
        });
    }, []);

    useEffect(() => {
        if (asset?.assetName && asset?.id != null) {
            updatePageTabTitle({
                title: asset.assetName,
                url: `/asset/${asset.id}`,
            });
        }
    }, [asset?.assetName, asset?.id]);

    if (!asset || !tabs) {
        return null;
    }

    return (
        <div className={`common-container ${isMobile ? "" : "container-height"} detail-list-layout asset-detail-list-layout border-l-gray`}>
            <DetailHeroSummaryProvider>
                <DetailTabBar tabs={tabs} setTabs={setTabs} hideTabs={isMobile} />
            {isMobile ? (
                flat && (
                    <AssetInfo
                        asset={asset}
                        flat={flat}
                        fields={fields}
                        customCodes={customCodes}
                        customStrings={customStrings}
                    />
                )
            ) : (
                <>
                    {tabs[0].clicked && flat && (
                        <AssetInfo
                            asset={asset}
                            flat={flat}
                            fields={fields}
                            customCodes={customCodes}
                            customStrings={customStrings}
                        />
                    )}
                    {tabs[1].clicked && <AssetPurchase id={asset.id} />}
                    {tabs[2].clicked && <AssetLicense id={asset.id} />}
                    {tabs[3].clicked && <AssetContract id={asset.id} />}
                    {tabs[4]?.clicked && <AssetLease id={asset.id} />}
                    {tabs[5]?.clicked && <AssetDepreciation id={asset.id} name={asset.assetName} />}
                    {tabs[6].clicked && (
                        <CommonHistoryList id={asset.id} tableName={"자산관리"} />
                    )}
                    {tabs[7].clicked &&
                        (platFrom !== "IAM" ? <AssetMaintenance id={asset.id} /> : <AssetMenoTab id={asset.id} />)}
                </>
            )}
            </DetailHeroSummaryProvider>
        </div>
    );
}

export default AssetView;
